import { Map } from "immutable";
import { combineReducers } from "redux";
import * as actionTypes from "~/store/action_types";

const creditCard = (state, billingPaymentObject) => {
  return state.merge({
    type: billingPaymentObject.type,
    card_type: billingPaymentObject.card_type,
    card_number: billingPaymentObject.card_number,
    expiration_month: billingPaymentObject.expiration_month,
    expiration_year: billingPaymentObject.expiration_year,
    is_expired: billingPaymentObject.is_expired,
    expiration_date: billingPaymentObject.expiration_date,
  });
};

const billingAddress = (state, billingPaymentObject) => {
  return state.merge({
    type: billingPaymentObject.type,
    company_name: billingPaymentObject.company_name,
    name: billingPaymentObject.name,
    email: billingPaymentObject.email,
    vat_id: billingPaymentObject.vat,
    country: billingPaymentObject.country,
    address: billingPaymentObject.address,
    city: billingPaymentObject.city,
    region: billingPaymentObject.region,
    zip_code: billingPaymentObject.zip_code,
  });
};

const credit_card = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.EDIT_BILLING_ADDRESS_SUCCESS: {
      if (action.response && action.response.single) {
        return creditCard(state, action.response.single);
      }

      return state;
    }
    case actionTypes.FETCH_BILLING_PAYMENT_METHOD_SUCCESS: {
      if (
        action.response &&
        action.response.entities &&
        action.response.entities.billingPaymentMethod &&
        action.response.result &&
        action.response.result.single
      ) {
        return creditCard(state, action.response.entities.billingPaymentMethod[action.response.result.single]);
      }

      return state;
    }
    case actionTypes.FETCH_ACCOUNT_SETTINGS_SUCCESS: {
      if (action.response && action.response.payment_method) {
        return creditCard(state, action.response.payment_method);
      }

      return state;
    }
    case actionTypes.SET_PAYMENT_METHOD_TYPE: {
      return state.set(`type`, action.paymentMethodType);
    }
    default:
      return state;
  }
};

const billing_address = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.ADD_BILLING_ADDRESS_SUCCESS:
    case actionTypes.EDIT_BILLING_ADDRESS_SUCCESS: {
      if (action.response && action.response.single) {
        return billingAddress(state, action.response.single);
      }

      return state;
    }
    case actionTypes.FETCH_BILLING_PAYMENT_METHOD_SUCCESS: {
      if (
        action.response &&
        action.response.entities &&
        action.response.entities.billingPaymentMethod &&
        action.response.result &&
        action.response.result.single
      ) {
        return billingAddress(state, action.response.entities.billingPaymentMethod[action.response.result.single]);
      }

      return state;
    }
    case actionTypes.FETCH_ACCOUNT_SETTINGS_SUCCESS: {
      if (action.response && action.response.payment_method) {
        return billingAddress(state, action.response.payment_method);
      }

      return state;
    }
    case actionTypes.SET_PAYMENT_METHOD_TYPE: {
      return state.set(`type`, action.paymentMethodType);
    }
    default:
      return state;
  }
};

const submittingStripe = (state = false, action) => {
  switch (action.type) {
    case actionTypes.CREATE_STRIPE_TOKEN_LOADING: {
      return true;
    }

    case actionTypes.CREATE_STRIPE_TOKEN_SUCCESS: {
      return false;
    }

    case actionTypes.CREATE_STRIPE_TOKEN_ERROR: {
      return false;
    }

    default:
      return state;
  }
};

const submittingPaymentMethod = (state = false, action) => {
  switch (action.type) {
    case actionTypes.ADD_BILLING_ADDRESS_LOADING:
    case actionTypes.EDIT_BILLING_ADDRESS_LOADING: {
      return true;
    }

    case actionTypes.ADD_BILLING_ADDRESS_SUCCESS:
    case actionTypes.EDIT_BILLING_ADDRESS_SUCCESS: {
      return false;
    }

    case actionTypes.ADD_BILLING_ADDRESS_ERROR:
    case actionTypes.EDIT_BILLING_ADDRESS_ERROR: {
      return false;
    }

    default:
      return state;
  }
};

export default combineReducers({
  credit_card,
  billing_address,
  submittingStripe,
  submittingPaymentMethod,
});
